<template>
  <div>
    <img src="/assets/img/oirp-top-banner-new.png" class="mt-5 mb-5" />

    <div class="row mt-4">
      <!-- <div class="col-md-4 d-md-none">
        <img
          src="/assets/img/NWW_signal_new.jpg"
          style="max-width: 100%; max-height: 100%; margin: 0 auto"
        />
      </div> -->
      <div class="col-md-12 align-items-stretch">
        <div
          class="ang-card card-icon-bg card-icon-bg-primary o-hidden mb-30 text-center"
        >
          <!---->
          <!---->
          <div class="ang-card-body d-flex flex-column">
            <h5 class="ang-card-title">
              Dlaczego warto przystąpić do grupowego ubezpieczenia dla OIRP?
            </h5>
            <div class="content p-3">
              <ul style="list-style: disc" class="pl-5">
                <li>
                  możliwość przystąpienia do ubezpieczenia pracownika,
                  partnera/ki oraz dorosłych dzieci - każdy może mieć swoje
                  ubezpieczenie
                </li>
                <li>
                  wysokie świadczenia za niską składkę dotyczące życia i zdrowia
                </li>
                <li>prosty sposób zapisu - poprzez formularz online</li>
                <li>indywidualne płatności przez każdą osobę ubezpieczoną</li>
                <li>ochrona przez 24h na całym świecie</li>
              </ul>
              <div class="mt-5">
                <p>Koniecznie zapoznaj się też z dokumentami:</p>
                <ul style="list-style: disc" class="pl-5">
                  <li class="font-semibold text-blue-600">
                    <a
                      href="https://angfinanse.pl/ubezpieczenia_oferta/OWU_Hestia_Rodzina_HR_01.15_20231016.pdf"
                      target="_blank"
                      >Ogólne Warunki Grupowego Ubezpieczenia na Życie
                      Pracowników i Ich Rodzin Hestia Rodzina</a
                    >
                  </li>
                  <li class="font-semibold text-blue-600">
                    <a
                      href="https://angfinanse.pl/ubezpieczenia_oferta/OWU_Medical_Assistance_MAS_01.12_20231016.pdf"
                      target="_blank"
                      >Ogólne Warunki Dodatkowego Grupowego Ubezpieczenia
                      Medical Assistance</a
                    >
                  </li>
                  <li class="font-semibold text-blue-600">
                    <a
                      href="https://angfinanse.pl/ubezpieczenia_oferta/Porownanie_wariantow.pdf"
                      target="_blank"
                      >Porównanie wariantów</a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p class="h5 mt-6 text-center p-5 mb-5">
      Zanim dokonasz zakupu ubezpieczenia, wypełnij formularz i zapoznaj się z
      informacją o przetwarzaniu Twoich danych
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>
